var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('chart',{ref:"chart",attrs:{"title":_vm.$t('sms.reports.status'),"data":_vm.data,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }